import * as React from 'react';
import { SVGProps } from 'react';

const SvgBusinessAccount = (props: SVGProps<SVGSVGElement>) => (
  <svg width={32} height={32} viewBox="0 0 32 32" fill="none" role="img" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.31 13.742c.359 2.96 2.923 6.018 5.268 6.018 2.666 0 5.221-3.213 5.617-6.018.156-.1.395-.363.496-.953 0 0 .57-2.032-.193-1.806.029-.084.077-.204.136-.35.484-1.204 1.713-4.259-.688-5.367C19.78 2.144 11.45 1.953 9.952 6.564c0 0-.478 1.125.165 4.465-.91-.436-.294 1.77-.294 1.77.092.59.33.844.487.943ZM3.46 25.94A15.971 15.971 0 0 0 16 32c5.08 0 9.607-2.367 12.538-6.06-.626-1.792-1.279-2.823-1.965-3.099 0 0-2.039-.799-6.1-2.405-2.066 5.392-3.104 8.087-3.104 8.087-.303-3.884-.46-5.818-.46-5.818.956-.79 1.58-1.652 1.893-2.568A4.476 4.476 0 0 1 16 21.425a4.524 4.524 0 0 1-2.793-1.288c.313.925.946 1.779 1.893 2.568l-.469 5.819s-1.038-2.696-3.096-8.088c-4.078 1.607-6.108 2.405-6.108 2.405-.686.27-1.342 1.302-1.967 3.098Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgBusinessAccount;
